/** @file Dialog for applying a saved team directly to the current editor board. */
import { h } from "./dom.js";
import { openModal } from "./modal.js";

/** @typedef {import("../types/schemas.js").TeamDoc} TeamDoc */

/**
 * @param {{ teams: TeamDoc[] }} opts
 * @returns {Promise<string | null>}
 */
export function openTeamApplyDialog({ teams }) {
  return openModal((close) => {
    const select = /** @type {HTMLSelectElement} */ (
      h(
        "select",
        { class: "hb-auth-input", autofocus: true },
        teams.map((team) => h("option", { value: team.id }, [team.name])),
      )
    );
    const apply = h(
      "button",
      { type: "submit", class: "hb-btn hb-btn--primary min-h-11" },
      ["Team anwenden"],
    );
    const cancel = h("button", { type: "button", class: "hb-btn min-h-11" }, ["Abbrechen"]);
    cancel.addEventListener("click", () => close(null));

    const form = h("form", { class: "flex flex-col gap-3" }, [
      h("h2", { class: "text-xl font-bold" }, ["Team auf Spielzug anwenden"]),
      h("p", { class: "text-sm text-neutral-300" }, [
        "Wählt Farbe und Rückennummern des Teams sofort für die Heimspieler im aktuellen Spielzug.",
      ]),
      h("label", { class: "flex flex-col gap-1 text-sm" }, [
        h("span", null, ["Team"]),
        select,
      ]),
      h("div", { class: "flex gap-2 justify-end mt-2" }, [cancel, apply]),
    ]);
    form.addEventListener("submit", (event) => {
      event.preventDefault();
      close(select.value || null);
    });
    setTimeout(() => select.focus(), 0);
    return form;
  });
}
